import React from "react";
import { Formik, FormikHelpers } from "formik";
import { Form, FormControls, FormTitle, IntentText } from "~/components/Form";
import { IModalComponent, IModalComponentClose } from "~/components/Modal";
import { getReleaseIntervalStatusLabel, IReleaseInterval } from "~/modules/Clients/models/AccountInfo";
import { FormNotice } from "~/components/FormNotice/FormNotice";
import { Table } from "~/components/Table";
import { Button } from "~/components/Button";
import { Intent } from "~/lib/intent";
import { stringDateFormat } from "~/lib/date";
import { getGranularityDateFormat } from "~/modules/Dashboard/lib/performance";
import { Granularity } from "~/modules/Dashboard/models/Performance";

type RequestPaymentFormProps = {
  sellerName: string;
  intervals: IReleaseInterval[];
  onSubmit: (formikActions: FormikHelpers<never[]>, close?: IModalComponentClose) => void;
};

export const RequestPaymentForm: IModalComponent<RequestPaymentFormProps> = (props) => {
  const dailyDateFormat = getGranularityDateFormat(Granularity.DAILY);

  return (
    <Formik initialValues={[]} onSubmit={(_data, actions) => props.onSubmit(actions, props.close)}>
      {(formik) => {
        const { status, isSubmitting } = formik;
        return (
          <Form>
            <FormTitle>Request payments for {props.sellerName}</FormTitle>

            {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
            <FormNotice message="The payment including all this intervals will be created on trolley side." />
            <Table
              header
              columns={[
                {
                  header: "Release ID",
                  field: "releaseId",
                },
                {
                  header: "Start",
                  cell: (interval) => stringDateFormat(interval.interval.start, dailyDateFormat),
                },
                {
                  header: "End",
                  cell: (interval) => stringDateFormat(interval.interval.end, dailyDateFormat),
                },
                {
                  header: "Status",
                  cell: (interval) => getReleaseIntervalStatusLabel(interval.status),
                },
              ]}
              records={props.intervals}
            />

            <FormControls>
              <Button disabled={isSubmitting} onClick={props.close}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting}
                intent={Intent.PRIMARY}
                rightIcon={isSubmitting && <i className="fa fa-spinner fa-spin" />}
              >
                Request payments
              </Button>
            </FormControls>
          </Form>
        );
      }}
    </Formik>
  );
};
